/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElDropdown as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/dropdown/style/css';
import { ElDropdownMenu as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/dropdown-menu/style/css';
import { ElDropdownItem as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/dropdown-item/style/css';
import __unplugin_components_4 from '~icons/custom/document';
import { ElIcon as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_2 from '~icons/custom/down';
import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadioButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio-button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-19dafa7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top-items"
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "12px"
  }
}, "下载任务", -1));
const _hoisted_5 = {
  class: "top-item"
};
const _hoisted_6 = {
  class: "flex-center"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "12px"
  }
}, "文档中心", -1));
const _hoisted_8 = {
  class: "top-item"
};
import ChangeGame from './changeGame.vue';
import { useTaskStore } from '@/store/modules/downTask';
import useLogout from './logout';
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'topbar',
  setup(__props) {
    const Guide = defineAsyncComponent(() => import('./guide.vue'));
    const DownTasks = defineAsyncComponent(() => import('@/components/DownTasks/index.vue'));
    const options = [{
      key: 'document',
      title: '开发者文档'
    }, {
      key: 'guide',
      title: '运营工具指南'
    }];
    const currentRoute = ref('');
    const {
      setShowTask
    } = useTaskStore();
    const handleLogout = useLogout();
    const {
      gameType
    } = storeToRefs(useAppStore());
    const handleClick = key => {
      if (key === 'document') {
        window.open(process.env.VUE_APP_OFFICIAL_DOC, '_blank');
      } else if (key === 'guide') {
        // showGuide.value = true;
        window.open('https://herogames.feishu.cn/wiki/Mfcvwu8xTiFmKLkZr68cguSUnSg', '_blank');
      } else if (key === 'update') {
        // to do
      } else if (key === 'down') {
        setShowTask(true);
      }
    };
    const showGuide = ref(false);
    const handleClose = () => {
      showGuide.value = false;
    };
    const route = useRoute();
    watch(() => route, val => {
      currentRoute.value = val.name;
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_radio_button = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      const _component_i_custom_down = __unplugin_components_2;
      const _component_el_icon = __unplugin_components_3;
      const _component_i_custom_document = __unplugin_components_4;
      const _component_el_dropdown_item = __unplugin_components_5;
      const _component_el_dropdown_menu = __unplugin_components_6;
      const _component_el_dropdown = __unplugin_components_7;
      const _component_el_button = __unplugin_components_8;
      const _directive_has = _resolveDirective("has");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createVNode(ChangeGame, {
        class: "marginR20"
      }, null, 512), [[_vShow, _unref(currentRoute) !== 'Home']]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_radio_group, {
        modelValue: _unref(gameType),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(gameType) ? gameType.value = $event : null),
        size: "large"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          label: "app"
        }, {
          default: _withCtx(() => [_createTextVNode("App")]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          label: "miniapp"
        }, {
          default: _withCtx(() => [_createTextVNode("微信小游戏")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_has, 'miniappSDK']])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "top-item",
        onClick: _cache[1] || (_cache[1] = $event => handleClick('down'))
      }, [_createVNode(_component_el_icon, {
        size: 16
      }, {
        default: _withCtx(() => [_createVNode(_component_i_custom_down)]),
        _: 1
      }), _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_dropdown, {
        trigger: "hover"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, item => {
            return _createVNode(_component_el_dropdown_item, {
              key: item.key,
              onClick: $event => handleClick(item.key)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
              _: 2
            }, 1032, ["onClick"]);
          }), 64))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_icon, {
          size: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_i_custom_document)]),
          _: 1
        }), _hoisted_7])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
        onClick: _unref(handleLogout),
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("登出")]),
        _: 1
      }, 8, ["onClick"])])])]), _unref(showGuide) ? (_openBlock(), _createBlock(_unref(Guide), {
        key: 0,
        onClose: handleClose
      })) : _createCommentVNode("", true), _createVNode(_unref(DownTasks))], 64);
    };
  }
});